module.exports = __webpack_public_path__ + "img/recipe-page.9ae5414d.png";